module.exports = __webpack_public_path__ + "static/ally-OSE-0503d338b6cf03d8603242b20e97fbd5.png";